var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TipTap',{attrs:{"content":_vm.content,"style-settings":_vm.styleSettings,"iframe-extension":"","image-extension":""},on:{"update:content":function($event){_vm.content=$event}}})}
var staticRenderFns = []

export { render, staticRenderFns }